const VALUE_PROP_NAMES = {
  CONTROL: 'control',
  ONE_NUMBER: 'oneNumber',
  FINANCIAL_ADVICE: 'financialAdvice',
  CASHFLOW_GOAL: 'cashflowGoal',
};

const VALUE_PROPS = [
  {
    name: VALUE_PROP_NAMES.CASHFLOW_GOAL,
    imageName: 'no-overdraft.png',
    title: 'עם riseup אפשר',
    subtitle: 'riseup מאפשר לך לראות צמיחה חיובית וחיסכון תוך 3 חודשים או פחות!',
  },
  {
    name: VALUE_PROP_NAMES.CONTROL,
    imageName: 'group-7@3x.png',
    title: 'אפשר לעשות סדר במצב הכלכלי ולהנות משקט נפשי',
    subtitle: 'riseup מרכז את כל ההכנסות וההוצאות במקום אחד, ונותן לך תמונת מצב חודשית באופן אוטומטי ופשוט.',
  },
  {
    name: VALUE_PROP_NAMES.ONE_NUMBER,
    imageName: 'how-much.png',
    title: 'עם התזרים של riseup אפשר לדעת כמה כסף נשאר להוציא',
    subtitle: 'תזרים riseup יודע כבר בתחילת החודש כמה כסף ייכנס, כמה עומד לצאת ומציג לך מספר אחד שמראה כמה נשאר להוציא.',
  },
  {
    name: VALUE_PROP_NAMES.FINANCIAL_ADVICE,
    imageName: 'group-cx@3x.png',
    title: 'אפשר להתייעץ בכל רגע שצריך',
    subtitle: 'הצוות שלנו מלווה אותך בתהליך הצמיחה הכלכלית שלך וזמין בשבילך בכל התלבטות כלכלית, קטנה או גדולה.',
  },
];

export default {
  VALUE_PROPS,
  VALUE_PROP_NAMES,
};



// WEBPACK FOOTER //
// ./src/pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/consts/value-props.js